import { render } from "./Time.vue?vue&type=template&id=633f5cfa&scoped=true"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"

import "./Time.vue?vue&type=style&index=0&id=633f5cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633f5cfa"]])

export default __exports__